import { productDetailsImageCarouselStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageCarousel";
import { css } from "styled-components";

productDetailsImageCarouselStyles.imageCarousel = {
    image: {
        css: css`
            height: 68px;
            width: 68px;
            border: 1px solid #cccccc;
        `,
    },
    selectedImage: {
        css: css`
            height: 68px;
            width: 68px;
            border: 1px solid #0f0f0f;
        `,
    },
};
